module.exports = __webpack_public_path__ + "/login_ui/img/ec-00a71e45c82e76b16f69eb1081842261.svg";